import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { selectors } from 'app-webtech-core';
import url from 'url';
import * as chatSelectors from 'app-modules/chat/selectors';
import { TYPE as EMBED_TYPE } from 'app-modules/embed/constants';
import { properties as embedSelector } from 'app-modules/embed/selectors';
import { properties as desktopSelector } from 'app-modules/desktop/selectors';
import { ApplicationRootComponent } from '../components/Application';
import { trendingIsEnabledSelector } from '../../trending/selectors/isEnabled';
import { saveUserConsent } from '../../application/actions/';
import { userCountryAreaSelector } from '../selectors/userCountryArea';
import { checkMobileOperatingSystem } from '../utils/checkMobileOperatingSystem';

const mapStateToProps = (state) => {
  const embedState = embedSelector(state);
  const headerVisible =
    (!embedState.enabled && !embedState.corpEmbed) || embedState.type === EMBED_TYPE.EMBED_TYPE_ALL;
  const isEmbed = embedState.enabled || embedState.corpEmbed;
  const trendingVisible =
    (!embedState.enabled || !embedState.corpEmbed) && trendingIsEnabledSelector(state);
  const guideVisible = embedState.type !== EMBED_TYPE.EMBED_TYPE_HEADLESS;
  const isConfigured = state.application.isConfigured;
  const consentSettings = state.applicationinternal.consentSettings;
  const TOSNotificationVisible = isConfigured && !embedState.disableTOSNotification;
  const isPrivacyNotificationHidden = state.applicationinternal.hidePrivacyNotification;
  const desktopState = desktopSelector(state);
  const userCountryArea = userCountryAreaSelector(state);
  const { isIos, isAndroid } = checkMobileOperatingSystem();
  const parsedUrl = url.parse(window.location.href, true);
  const launchPlayerAsFullscreenSplashPage =
    parsedUrl.query.fullscreen === 'true' && parsedUrl.query.utmCampaign === 'scener';

  return {
    isChatVisible: chatSelectors.isVisible(state),
    isPlayerEnabled: selectors.location.page(state) !== 'ChatOnly',
    isConfigured,
    isEmbed,
    headerVisible,
    trendingVisible,
    guideVisible,
    consentSettings,
    deviceType: desktopState.enabled ? 'desktop' : 'web',
    TOSNotificationVisible,
    isPrivacyNotificationHidden,
    userCountryArea,
    isMobile: isIos || isAndroid,
    launchPlayerAsFullscreenSplashPage: launchPlayerAsFullscreenSplashPage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveUserConsent: (payload) => dispatch(saveUserConsent(payload)),
});

const ApplicationRoot = connect(mapStateToProps, mapDispatchToProps)(ApplicationRootComponent);

const HotApplication = hot(module)(ApplicationRoot);

export { HotApplication as Application };
